import { isString } from "./string";
export var hasWindow = function hasWindow() {
  return typeof window !== "undefined";
};
export var toArray = function toArray(nodeList) {
  return Array.prototype.slice.call(nodeList);
};
export var loaded = function loaded(elem) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "idpc";
  return elem.getAttribute(prefix) === "true";
};
export var markLoaded = function markLoaded(elem) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "idpc";
  return elem.setAttribute(prefix, "true");
};

var isTrue = function isTrue() {
  return true;
};

export var getParent = function getParent(node, entity) {
  var test = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isTrue;
  var parent = node;
  var tagName = entity.toUpperCase();

  while (parent.tagName !== "HTML") {
    if (parent.tagName === tagName && test(parent)) return parent;
    if (parent.parentNode === null) return null;
    parent = parent.parentNode;
  }

  return null;
};
export var toHtmlElem = function toHtmlElem(parent, selector) {
  return selector ? parent.querySelector(selector) : null;
};
export var getAnchors = function getAnchors(selector, d) {
  var matches = (d || window.document).querySelectorAll(selector);
  var anchors = toArray(matches).filter(function (e) {
    return !loaded(e);
  });
  if (anchors.length === 0) return [];
  anchors.forEach(function (anchor) {
    return markLoaded(anchor);
  });
  return anchors;
};
export var insertBefore = function insertBefore(_ref) {
  var elem = _ref.elem,
      target = _ref.target;
  var parent = target.parentNode;
  if (parent === null) return;
  parent.insertBefore(elem, target);
  return elem;
};
export var toElem = function toElem(elem, context) {
  if (isString(elem)) return context.querySelector(elem);
  return elem;
};

var d = function d() {
  return window.document;
};

export var getScope = function getScope(scope) {
  if (isString(scope)) return d().querySelector(scope);
  if (scope === null) return d();
  return scope;
};
export var getDocument = function getDocument(scope) {
  if (scope instanceof Document) return scope;
  if (scope.ownerDocument) return scope.ownerDocument;
  return d();
};
export var setStyle = function setStyle(element, style) {
  var currentRules = element.getAttribute("style");
  Object.keys(style).forEach(function (key) {
    return element.style[key] = style[key];
  });
  return currentRules;
};
export var restoreStyle = function restoreStyle(element, style) {
  element.setAttribute("style", style || "");
};
export var hide = function hide(e) {
  e.style.display = "none";
  return e;
};
export var show = function show(e) {
  e.style.display = "";
  return e;
};
export var remove = function remove(elem) {
  if (elem === null || elem.parentNode === null) return;
  elem.parentNode.removeChild(elem);
};
export var contains = function contains(scope, selector, text) {
  var elements = scope.querySelectorAll(selector);

  for (var i = 0; i < elements.length; i++) {
    var e = elements[i];
    var content = e.innerText;
    if (content && content.trim() === text) return e;
  }

  return null;
};